/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_4a3b28eb"]'><cube-button light>明亮按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_4a3b28eb"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_4a3b28eb"}
  /** script content **/
  require("./btn-light.mpx.js?isComponent&outputPath=components%2Fbtn-light4a3b28eb%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-light.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-light4a3b28eb%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_4a3b28eb"],
    ctorType: "component",
    outputPath: "components/btn-light4a3b28eb/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>